import React from 'react';
import { Box, Flex, Text, VStack, HStack } from '@chakra-ui/react';
import { ShieldCheckIcon, RefreshCwIcon, CreditCardIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <Box bg="rgba(127, 29, 29, 0.2)" borderWidth="2px" borderColor="red.700" borderRadius="xl" p={6} shadow="xl" data-id="element-217">
      <VStack spacing={4} align="stretch" data-id="element-218">
        <Flex align="center" gap={3} data-id="element-219">
          <Box bg="red.600" color="white" p={3} borderRadius="full" data-id="element-220">
            <ShieldCheckIcon size={32} data-id="element-221" />
          </Box>
          <Box data-id="element-222">
            <Text fontSize="2xl" fontWeight="bold" color="white" data-id="element-223">
              🛡️ GARANTÍA TOTAL — 7 DÍAS
            </Text>
          </Box>
        </Flex>

        <Text color="gray.300" fontSize="md" lineHeight="tall" data-id="element-224">
          Si en 7 días no ves señales, no sientes cambios ni percibes ninguna
          transformación energética…
        </Text>

        <VStack spacing={3} align="stretch" pl={4} data-id="element-225">
          <HStack spacing={3} data-id="element-226">
            <RefreshCwIcon size={20} color="#DC2626" data-id="element-227" />
            <Text fontWeight="semibold" color="gray.300" data-id="element-228">
              🆓 Asistencia personalizada sin costo adicional
            </Text>
          </HStack>
          <HStack spacing={3} data-id="element-229">
            <CreditCardIcon size={20} color="#DC2626" data-id="element-230" />
            <Text fontWeight="semibold" color="gray.300" data-id="element-231">
              💰 Devolución del 100% de tu dinero — sin preguntas
            </Text>
          </HStack>
        </VStack>

        <Text fontSize="lg" fontWeight="bold" color="red.300" textAlign="center" mt={2} data-id="element-232">
          Compras con total tranquilidad o no compras.
        </Text>
      </VStack>
    </Box>;
}